import {USER_DATA} from 'src/app/_interfaces/auth.interface'
import {PlatformDataType} from 'src/interfaces/Platform.interface'

export type AccountMilestone = {
  id: string
  label: string
  complete: boolean
}

export type AccountSetupProgress = {
  percent: number
  milestones: AccountMilestone[]
  remainingCount: number
  isComplete: boolean
  fields?: Record<string, boolean>
  isLoading?: boolean
}

export const getAccountSetupProgress = (
  user: USER_DATA | null | undefined,
  connectedPlatforms: PlatformDataType[] = []
): AccountSetupProgress => {
  const hasDestinationChannel = connectedPlatforms.some(
    (p) => !(p.isMainStore || p.isAccountingStore || p.isShippingStore)
  )

  const milestones: AccountMilestone[] = [
    {id: 'name', label: 'Profile name', complete: Boolean(user?.name && String(user.name).trim())},
    {id: 'phone', label: 'Phone number', complete: Boolean(user?.isPhoneNumberStepDone)},
    {id: 'company', label: 'Company details', complete: Boolean(user?.company_name?.trim())},
    {id: 'channel', label: 'Connect a sales channel', complete: hasDestinationChannel},
    {id: 'onboarding', label: 'Complete onboarding', complete: Boolean(user?.isOnboardingProcessCompleted)},
    {id: 'subscription', label: 'Active subscription', complete: Boolean(user?.is_subscribed)},
  ]

  const completeCount = milestones.filter((m) => m.complete).length
  const percent = milestones.length ? Math.round((completeCount / milestones.length) * 100) : 0

  return {
    percent,
    milestones,
    remainingCount: milestones.length - completeCount,
    isComplete: percent >= 100,
  }
}

export const getUserInitials = (name?: string | null, email?: string | null): string => {
  const source = (name || email || 'U').trim()
  const parts = source.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase()
  }
  return source.slice(0, 2).toUpperCase()
}
